import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import DashboardHeader from "../navigation/DashboardHeader";
import Aside from "../navigation/Aside";
import { loadUserRole } from "../helpers/HelperFunctions";

// will contunue to component if is authnticated
const EmployeeRoute = ({ isAuthenticated, role, component: Component, ...rest }) => (
	<Route {...rest} render={(props) => ((isAuthenticated && (role===1 || role===2 || role===4)) ? 
		(
			<div className="dashboard-page">
				<DashboardHeader aside />
				<Aside location={props.location} />
				<div className="dashboard-container">
					<Component {...props} />
				</div>
			</div>
		) 
		: 
		<Redirect to="/dashboard" />)} />
);

EmployeeRoute.defaultProps = {
	role: null,
};

EmployeeRoute.propTypes = {
	component: PropTypes.func.isRequired,
	isAuthenticated: PropTypes.bool.isRequired,
	role: PropTypes.number,
	location: PropTypes.shape({
		hash: PropTypes.string,
		key: PropTypes.string,
		pathname: PropTypes.string,
		search: PropTypes.string
	}).isRequired,
};

function mapStateToProps(state) {
	return {
		isAuthenticated: !!(state.userLoginData && state.userLoginData.token),
		role: (state.userLoginData && state.userLoginData.user && loadUserRole(state.userLoginData.user.roles))
	};
};

export default connect(mapStateToProps)(EmployeeRoute);


// WEBPACK FOOTER //
// ./src/components/routes/EmployeeRoute.js